import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {CryptoService} from './crypto.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';

export const STORE_KEY_dateFormat = 'dateFormat';
export const STORE_KEY_tempUnit = 'tempUnit';
export const STORE_KEY_defaultHomePage = 'defaultHomePage';
export const STORE_KEY_summaryDashboard = 'summaryDashboardchecked';
export const STORE_KEY_summaryEmail = 'summaryEmailchecked';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {
  dateFormat: string;
  dateFormatForCal: string;
  tempUnit: string;
  defaultHomePage: number; // 0: Dashboard, 1: GlobalMap
  summaryDashboardchecked: boolean;
  summaryEmailchecked: boolean;
  tempChangedDetect = new BehaviorSubject<any>('');
  constructor(private http: HttpClient, private cryptoService: CryptoService) {
    this.dateFormat = 'yyyy/MM/dd';
    // this.dateFormatForCal = 'yy/mm/dd';
    this.tempUnit = '℃';
    this.defaultHomePage = 0;
    this.Initial();
  }

  Initial() {
    this.dateFormat = 'yyyy/MM/dd';
    this.dateFormat = this.GetDateFormat;
    this.tempUnit = this.GetTempUnit;
    this.summaryDashboardchecked = this.GetDefaultSummaryDashboard;
    this.summaryEmailchecked = this.GetDefaultSummaryEmail;
    // this.dateFormatForCal = this.GetDateFormat.replace('yyyy', 'yy').replace('MM', 'mm');
  }

  set SetDateFormat(value) {
    localStorage.setItem(STORE_KEY_dateFormat, value);
    this.dateFormat = value;
    // this.dateFormatForCal = value.replace('yyyy', 'yy').replace('MM', 'mm');
  }

  get GetDateFormat() {
    const data = localStorage.getItem(STORE_KEY_dateFormat);
    return data || 'yyyy/MM/dd';
  }

  set SetTempUnit(value) {
    localStorage.setItem(STORE_KEY_tempUnit, value);
    this.tempUnit = value;
  }

  get GetTempUnit() {
    const data = localStorage.getItem(STORE_KEY_tempUnit);
    return data || '℃';
  }

  set SetDefaultHomePage(value) {
    localStorage.setItem(STORE_KEY_defaultHomePage, value);
    this.defaultHomePage = value;
  }

  get GetDefaultHomePage() {
    const data = localStorage.getItem(STORE_KEY_defaultHomePage);
    return (data === '0' || data === '1' || data === '2' || data === '3') ? Number(data) : 0;
  }

  set SetDefaultSummaryDashboard(value) {
    localStorage.setItem(STORE_KEY_summaryDashboard, value);
    this.summaryDashboardchecked = value;
  }

  get GetDefaultSummaryDashboard() {
    const data = localStorage.getItem(STORE_KEY_summaryDashboard);
    return (data === 'true') ? true : false;
  }


  set SetDefaultSummaryEmail(value) {
    localStorage.setItem(STORE_KEY_summaryEmail, value);
    this.summaryEmailchecked = value;
  }

  get GetDefaultSummaryEmail() {
    const data = localStorage.getItem(STORE_KEY_summaryEmail);
    return (data === 'true') ? true : false;
  }

  TempChangedDetect$(): Observable<any> {
    return this.tempChangedDetect;
  }

  UpdateAccountPreference(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/preference/update`, params);
  }

  ReadAccountPreference(otp): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/preference/read`, {otp: otp});
  }

  UpdateAccountPreferenceWithAuthOTP(params): Observable <any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/account/preference/update/authotp`, params);
  }

  DeleteMobile(params): Observable <any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/account/preference/mobile/delete`, params);
  }
}
